(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
// document.addEventListener("DOMContentLoaded", function() {
//   if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
//     $('.custom-hero-slider').slick({
//       dots: true,
//       arrows: false,
//       autoplay: false,
//       autoplaySpeed: 5000,
//       infinite: true,
//       speed: 500,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       adaptiveHeight: false
//     });
//   } else {
//     console.error("jQuery or Slick Slider not loaded!");
//   }
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.testimonial-slider').slick({
      centerMode: true,
    //   centerPadding: '160px',
      slidesToShow: 3,
      arrows: true,
      dots: true,
      infinite: true,
      speed: 600,
      prevArrow: '<button type="button" class="slick-prev">‹</button>',
      nextArrow: '<button type="button" class="slick-next">›</button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerPadding: '20px',
            slidesToShow: 1,
            centerMode: false,
          }
        },
        {
          breakpoint: 767,
          settings: {
            centerPadding: '20px',
            slidesToShow: 1,
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();
})();
